import { Layout } from '@/utils/routerHelper'

// 库存管理
export default {
  path: '/stock',
  redirect: '/stock/stock-list',
  component: Layout,
  name: 'Stock',
  meta: {
    title: '库存管理',
    icon: 'vi-ant-design:dashboard-filled',
    alwaysShow: true
  },
  children: [
    {
      path: 'stock-list',
      component: () => import('@/views/Stock/StockList/Index.vue'),
      name: 'StockList',
      meta: {
        title: '库存列表'
      },
      children: [
        {
          path: 'detail',
          component: () => import('@/views/Stock/StockChangeDetail/Index.vue'),
          name: 'StockChangeDetail',
          meta: {
            title: '库存列表明细列表',
            hidden: true,
            canTo: true,
            activeMenu: '/stock/stock-list'
          }
        }
      ]
    },
    {
      path: 'stock-change-audit',
      component: () => import('@/views/Stock/StockChangeAudit/Index.vue'),
      name: 'StockChangeAudit',
      meta: {
        title: '库存变动审批'
      },
      children: [
        {
          path: 'detail',
          component: () => import('@/views/Stock/AuditDetail/Index.vue'),
          name: 'StockChangeAuditDetail',
          meta: {
            title: '库存变动审批详情',
            hidden: true,
            canTo: true,
            activeMenu: '/stock/stock-change-audit'
          }
        }
      ]
    }
  ]
} as AppRouteRecordRaw
